/**
 * Un écran d'erreur qui dit quoi faire, pas seulement ce qui a raté.
 * Dans une iframe sans outils de développement, c'est la seule chose que la
 * personne aura pour comprendre.
 */
export default function Erreur({ message, onReessayer }) {
  return (
    <div className="centre">
      <h1 className="titre">Ça n'a pas marché</h1>
      <p className="discret">{message || 'Erreur inconnue.'}</p>
      <button type="button" onClick={onReessayer}>Réessayer</button>
    </div>
  );
}
